<template>
  <div
    class="bg-green-500 shadow-md rounded flex flex-col p-1 sm:p-2 md:p-2 lg:p-4 xl:p-4"
  >
    <div class="text-sm border-b-2 border-white border-dotted">
      Suggerimento:
    </div>
    <div
      class="text-xl uppercase leading-7 animate-pulse"
    >
      {{ hint }}
    </div>
    <div class="leading-4 text-base sm:text-base md:text-base lg:text-2xl xl:text-3xl uppercase px-1 py-1 font-bold text-white bg-orange-light rounded-sm shadow-sm">
      <a href="#ex1" rel="modal:open">Guarda la tabella e scopri perché</a>
    </div>
    <div id="ex1" class="modal">
      <BlackjackChart />
    </div>
  </div>
</template>

<script>
import store from "../store";
import BlackjackChart from "./BlackjackChart.vue";

export default {
  name: "Hint",
  store,
  components: { BlackjackChart },
  computed: {
    hint() {
      return this.$store.getters.hint;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Hint.vue